import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/icon/user-outline-grey.svg'
import _imports_1 from '@/assets/img/icon/bus-front-outline-grey.svg'


const _hoisted_1 = { class: "closed-list" }
const _hoisted_2 = { class: "flex items-center justify-between mb-5" }
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold" }, "Periode waktu:", -1)
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down" }, null, -1)
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-down" }, null, -1)
const _hoisted_9 = { class: "lg:w-1/4 w-full" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex items-center justify-between border-grey-3 px-4 py-3 background-grey-1" }
const _hoisted_13 = { class: "flex items-center gap-3" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex items-center justify-end gap-1" }
const _hoisted_17 = { class: "text-base font-bold text-grey" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "text-base font-bold text-grey" }, "|", -1)
const _hoisted_19 = { class: "text-base font-bold text-primary" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right" }, null, -1)
const _hoisted_21 = {
  key: 1,
  class: "rounded-lg text-grey border-grey-3 background-grey-2 px-2 py-1 ml-2"
}
const _hoisted_22 = {
  key: 0,
  class: "border-grey-3 py-3"
}
const _hoisted_23 = { class: "flex justify-between items-center pl-40px pr-4 py-3 border-bottom-grey-3" }
const _hoisted_24 = { class: "flex items-center gap-3 mb-1" }
const _hoisted_25 = { class: "text-base font-bold" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = /*#__PURE__*/_createTextVNode("Lihat Detail ")
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right text-primary text-sm font-bold" }, null, -1)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "flex items-center gap-3" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-5",
  alt: "user"
}, null, -1)
const _hoisted_33 = { class: "text-grey text-sm font-medium" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", null, "|", -1)
const _hoisted_35 = { class: "flex items-center gap-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "bus"
}, null, -1)
const _hoisted_37 = { class: "text-grey text-sm font-medium" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", null, "|", -1)
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-5",
  alt: "bus"
}, null, -1)
const _hoisted_41 = { class: "text-grey text-sm font-medium" }
const _hoisted_42 = {
  key: 0,
  class: "text-primary text-xs font-normal text-center border-primary py-1 px-2 rounded-md background-blue-4"
}
const _hoisted_43 = { class: "mt-2 text-green text-base font-bold" }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["onClick"]

import { getCurrentInstance, onMounted, reactive, ref } from 'vue'
import Card from 'primevue/card'
import InputIconRight from '@/views/components/form/InputIconRight.vue'
import { useRouter } from 'vue-router'
import { encryptDecriptMethods } from '@/plugins/encryptDecriptMethods'
import Paginator from '@/views/components/paginator/Paginator.vue'
import apiUseCase from '@/usecase/apiUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import Popper from 'vue3-popper'
import EmptyState from '@/views/components/list/EmptyState.vue'
import { useStore } from 'vuex'
import currencyNumberFormat from '@/utils/helpers/rupiahFormat'
import moment from 'moment'
import numberFormat from '@/utils/helpers/numberFormat'
import Button from 'primevue/button'
import Calendar from 'primevue/calendar'
import HjpConfirmationModal from '@/views/components/modal/HjpConfirmationModal.vue'
import OverlayPanel from 'primevue/overlaypanel'
import apiOpenUseCase from '@/usecase/apiOpenUseCase'
import MonthOptions from '../json/month'


export default /*#__PURE__*/_defineComponent({
  __name: 'ClosedList',
  setup(__props) {

const transactionPpsEndpoint = 'transaction/v2/TransactionPps'
const snackEndpoint = 'ticket/v1/Snacks'
const app = getCurrentInstance()
const {
  $icon, $toast
} = app!.appContext.config.globalProperties
const icon = $icon
const router = useRouter()
const store = useStore()
const placeholder = ref('Cari Disini...')
const emptyTable = ref('Data setoran belum tersedia')
const inputSearch = ref('')
const dataSource = ref([]) as any
const dataSourceDetail = ref([]) as any
const selectedData = ref(null) as any
const selectedMonth = ref({ name: moment().locale('id').format('MMMM'), value: moment().format('MM') })
const selectedYear = ref(new Date())
const refOverlayAction = ref()
const filterOptions = ref(0)
const monthOptions = ref(MonthOptions())
const selectedDataForReturnSnack = ref(null) as any

const filters = ref({
  search: '',
  filterField: ['q'],
  pageNumber: 1,
  pageSize: 10,
  totalRecords: 0,
  custom: [['startDate', '=', ''], ['endDate', '=', '']] as any
})

const filtersDetail = ref({
  search: '',
  filterField: ['trayekName'],
  pageNumber: 1,
  pageSize: 5,
  totalRecords: 0,
  custom: [] as any
})

const onSearch = () => {
  console.log('search', inputSearch.value)
  filters.value.search = inputSearch.value
  filters.value.pageNumber = 1
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const toDetailPage = (data: any, dataDetail: any) => {
  const payload = {
    ...dataDetail,
    headerId: data?.Id,
    PrintCode: data?.PrintCode
  }
  console.log('payload', payload)
  const encryptedId = encryptDecriptMethods.encrypt(payload)
  router.push({
    name: 'cashless-closed-deposits-detail',
    params: {
      id: encryptedId
    }
  })
}

const attrModalConfirmation = reactive({
  show: false,
  title: 'Transfer Snack Sisa?',
  subTitle: '',
  subTitleHtml: true,
  btnSubmitTitle: 'Terima Snack',
  btnBackTitle: 'Kembali',
  imgContent: require('@/assets/img/modal-confirmation/snack-confirmation.svg')
})

const hideDialogConfirmation = () => {
  attrModalConfirmation.show = false
  selectedDataForReturnSnack.value = null
}

const showDialogConfirmation = (data: any) => {
  // console.log('ss', data)
  selectedDataForReturnSnack.value = data
  attrModalConfirmation.subTitle = `Anda akan mentransfer <span class="font-bold">${numberFormat(selectedDataForReturnSnack.value?.TransactionPpSnackSummary.TotalSnackQuantityLeft ?? 0)} Snack Sisa</span> ke bagian Roster. Lanjutkan proses transfer?`
  attrModalConfirmation.show = true
}

const returnSnackAct = async () => {
  store.dispatch('showLoading')
  const building = await store.dispatch('userProfiles/fetchUserEmploymentAndBuilding')
  console.log('store', store.state)
  const payload = {
    FromBuildingId: null,
    FromBuildingName: null,
    ToBuildingId: building.id,
    ToBuildingName: building.name,
    ReferenceId: selectedDataForReturnSnack.value?.Id,
    TransferType: 'ReturnFromRoster',
    SnackTransferItems: [] as any
  }

  // eslint-disable-next-line no-unused-expressions, array-callback-return
  payload.SnackTransferItems = selectedDataForReturnSnack.value?.TransactionPpSnackSummary.Snacks.map((data: any) => ({
    SnackId: data.SnackId,
    Quantity: data.CurrentStock
  }))

  try {
    await apiOpenUseCase.postWithNoId(`${snackEndpoint}/Transfer`, payload).then((response) => {
      const { result, error, message } = response
      if (!error) {
        $toast.add({
          severity: 'success',
          detail: 'Snack berhasil disetor',
          group: 'bc',
          life: 3000
        })
        // eslint-disable-next-line no-use-before-define
        getAllData()
        hideDialogConfirmation()
      } else {
        $toast.add({
          severity: 'error',
          summary: 'Gagal menyetor snack',
          detail: message,
          group: 'bc',
          life: 3000
        })
      }
    })
  } catch (error) {
    $toast.add({
      severity: 'error',
      summary: 'Gagal menyimpan snack',
      detail: error,
      group: 'bc',
      life: 3000
    })
  }
  store.dispatch('hideLoading')
}

const onChangePage = ({ page, rows }: any) => {
  filters.value.pageNumber = page + 1
  filters.value.pageSize = rows
  // eslint-disable-next-line no-use-before-define
  getAllData()
}

const onChangePageDetail = ({ page, rows }: any) => {
  filtersDetail.value.pageNumber = page + 1
  filtersDetail.value.pageSize = rows
  // eslint-disable-next-line no-use-before-define
  getAllDataDetail()
}

const getAllData = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Completed`, returnUrlPrams(filters.value)).then((response) => {
    const { error, result, count } = response
    if (!error) {
      filters.value.totalRecords = count
      dataSource.value = result
    }
  })
  store.dispatch('hideLoading')
}

const getAllDataDetail = async () => {
  store.dispatch('showLoading')
  await apiUseCase.get(`${transactionPpsEndpoint}/NonCash/Completed/${selectedData.value?.Id}/TransactionPps`, returnUrlPrams(filtersDetail.value)).then((response) => {
    const { error, result, count } = response
    if (!error) {
      filtersDetail.value.totalRecords = count
      dataSourceDetail.value = result
    }
  })
  store.dispatch('hideLoading')
}

const openDetailSection = (data: any) => {
  if (selectedData.value?.Id === data?.Id) {
    selectedData.value = null
    dataSourceDetail.value = []
  } else {
    selectedData.value = data
    dataSourceDetail.value = []
    getAllDataDetail()
  }
}

const showPrintedStat = (item: any) => {
  // console.log('item', item)
  const token = localStorage.getItem('ut')
  const routeData = router.resolve({ name: 'reports-detail', params: { typeReport: `${item.Query}?${item.Parameter}=${item.closedId}` } })
  window.open(routeData.href, '_blank')
}

// const printClosedStat = async (closedId: string) => {
//   store.dispatch('showLoading')
//   await apiUseCase.postWithNoId(`${transactionPpsEndpoint}/NonCash/Completed/${closedId}/Print`).then((response) => {
//     const { error, result } = response
//     if (!error) {
//       const params = {
//         ...result,
//         closedId
//       }
//       showPrintedStat(params)
//       // window.location.reload()
//     }
//   })
//   store.dispatch('hideLoading')
// }

const printClosedStat = async (closedId: string) => {
  store.dispatch('showLoading')
  const payload = {}
  await apiUseCase.getBlob(`${transactionPpsEndpoint}/NonCash/Completed/${closedId}/Export`).then((response) => {
    const { error, result } = response
    if (!error) {
      $toast.add({
        severity: 'success',
        detail: 'Data berhasil didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
      const blob = result
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `laporan Setoran Non-Tunai (${moment().format('DD MMMM YYYY')}).pdf`
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    } else {
      $toast.add({
        severity: 'error',
        detail: 'Data gagal didownload',
        group: 'bc',
        closable: false,
        life: 3000
      })
    }
  })
  store.dispatch('hideLoading')
}

const onPrintAct = (data: any) => {
  printClosedStat(data.Id)
}

const showDropDown = (evt: any, filterOption: any) => {
  filterOptions.value = filterOption
  refOverlayAction.value.toggle(evt)
}

const hideOverlay = () => {
  refOverlayAction.value.hide()
}

const setStartAndEndDate = (month: any, year: any) => {
  const end = moment(`${year}-${month}-01`).endOf('month').format('DD')
  return [`${year}-${month}-01`, `${year}-${month}-${end}`]
}

const setPayloadAfterAdjustFilters = () => {
  const dateRange = setStartAndEndDate(selectedMonth.value?.value, moment(selectedYear.value).format('YYYY'))
  filters.value.custom.map(async (x: any, index: any) => {
    if (x[0] === 'startDate') {
      filters.value.custom[index][2] = dateRange[0]
    }
    if (x[0] === 'endDate') {
      filters.value.custom[index][2] = dateRange[1]
    }
  })
}

const selectYearAct = (data: any) => {
  selectedYear.value = data
  hideOverlay()
  selectedData.value = null
  filters.value.pageNumber = 1
  setPayloadAfterAdjustFilters()
  getAllData()
}

const selectMonthAct = (data: any) => {
  console.log('month', data)
  selectedMonth.value = data
  hideOverlay()
  selectedData.value = null
  filters.value.pageNumber = 1
  setPayloadAfterAdjustFilters()
  getAllData()
}

onMounted(() => {
  setPayloadAfterAdjustFilters()
  getAllData()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", {
          class: "flex items-center gap-2 background-grey-2 rounded-lg px-3 py-1 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showDropDown($event, 0)))
        }, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(selectedMonth.value?.name ?? '-'), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", {
          class: "flex items-center gap-2 background-grey-2 rounded-lg px-3 py-1 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (showDropDown($event, 1)))
        }, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(moment)(selectedYear.value).format('YYYY')), 1),
          _hoisted_8
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(InputIconRight, {
          class: "input-search-header-custom",
          placeholder: placeholder.value,
          modelValue: inputSearch.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputSearch).value = $event)),
          canClick: true,
          icon: _unref($icon).svg.searchEva,
          onSubmitInput: onSearch,
          onKeyup: _withKeys(onSearch, ["enter"])
        }, null, 8, ["placeholder", "modelValue", "icon", "onKeyup"])
      ])
    ]),
    (_unref(dataSource).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(EmptyState, { textNoData: emptyTable.value }, null, 8, ["textNoData"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), (data) => {
            return (_openBlock(), _createElementBlock("div", { key: data }, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, [
                    _createElementVNode("i", {
                      class: _normalizeClass(["cursor-pointer", `pi pi-angle-${_unref(selectedData)?.Id === data?.Id ? 'down' : 'right'}`]),
                      onClick: ($event: any) => (openDetailSection(data))
                    }, null, 10, _hoisted_14)
                  ]),
                  _createElementVNode("div", {
                    onClick: ($event: any) => (openDetailSection(data)),
                    class: "text-lg font-bold cursor-pointer"
                  }, _toDisplayString(`${data?.PrintCode}-${_unref(moment)(data?.CreatedAt).format('DD MMMM YYYY HH:mm')}`), 9, _hoisted_15)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, _toDisplayString(`(${_unref(numberFormat)(data?.TotalTransaction)} Stat)`), 1),
                  _hoisted_18,
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(currencyNumberFormat)(data?.TotalTicketAmount)), 1),
                  (!data?.HasTransferredSnack)
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        class: "btn-primary ml-2",
                        onClick: ($event: any) => (showDialogConfirmation(data))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Transfer Snack (" + _toDisplayString(_unref(numberFormat)(data?.TransactionPpSnackSummary.TotalSnackQuantityLeft ?? 0)) + ") ", 1),
                          _hoisted_20
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (data?.HasTransferredSnack)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Snack Ditransfer (" + _toDisplayString(_unref(numberFormat)(data?.TransactionPpSnackSummary.TotalSnackQuantityLeft ?? 0)) + ")", 1))
                    : _createCommentVNode("", true)
                ])
              ]),
              (_unref(selectedData)?.Id === data.Id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSourceDetail), (dataDetail) => {
                      return (_openBlock(), _createElementBlock("div", { key: dataDetail }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(dataDetail?.TrxId ?? '-'), 1),
                              _createElementVNode("div", {
                                class: "text-primary text-sm font-bold cursor-pointer",
                                onClick: ($event: any) => (toDetailPage(data, dataDetail))
                              }, _hoisted_29, 8, _hoisted_26)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _createElementVNode("div", _hoisted_31, [
                                _hoisted_32,
                                _createElementVNode("div", _hoisted_33, _toDisplayString(`Kondektur: ${dataDetail?.CondecturName ?? '-'}`), 1)
                              ]),
                              _hoisted_34,
                              _createElementVNode("div", _hoisted_35, [
                                _hoisted_36,
                                _createElementVNode("div", _hoisted_37, _toDisplayString(`Nopol: ${dataDetail?.VehicleRegNumber ?? '-'}`), 1)
                              ]),
                              _hoisted_38,
                              _createElementVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createElementVNode("div", _hoisted_41, _toDisplayString(`User Closing: ${dataDetail?.CompletedByFullName ?? '-'}`), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            (dataDetail?.HasNonCash)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Non Tunai"))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(currencyNumberFormat)(dataDetail?.TotalNonCashTicketAmount)), 1)
                          ])
                        ])
                      ]))
                    }), 128)),
                    _createElementVNode("div", null, [
                      _createVNode(Paginator, {
                        class: "trayek-pagination",
                        rows: filtersDetail.value.pageSize,
                        totalRecords: filtersDetail.value.totalRecords,
                        rowsPerPageOptions: [5, 10, 15, 20, 25],
                        onOnPage: onChangePageDetail
                      }, null, 8, ["rows", "totalRecords"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode(Paginator, {
            class: "trayek-pagination",
            rows: filters.value.pageSize,
            totalRecords: filters.value.totalRecords,
            rowsPerPageOptions: [5, 10, 15, 20, 25],
            onOnPage: onChangePage
          }, null, 8, ["rows", "totalRecords"])
        ])),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "refOverlayAction",
      ref: refOverlayAction
    }, {
      default: _withCtx(() => [
        (filterOptions.value === 1)
          ? (_openBlock(), _createBlock(_unref(Calendar), {
              key: 0,
              modelValue: selectedYear.value,
              "onUpdate:modelValue": [
                _cache[3] || (_cache[3] = ($event: any) => ((selectedYear).value = $event)),
                selectYearAct
              ],
              inline: "",
              view: "year",
              dateFormat: "yyyy"
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (filterOptions.value === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(monthOptions.value, (month, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("div", {
                    onClick: ($event: any) => (selectMonthAct(month)),
                    class: _normalizeClass(["cursor-pointer", selectedMonth.value.value === month.value ? 'text-primary' : ''])
                  }, _toDisplayString(month.name), 11, _hoisted_45)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(HjpConfirmationModal, {
      show: attrModalConfirmation.show,
      imgContent: attrModalConfirmation.imgContent,
      title: attrModalConfirmation.title,
      subTitle: attrModalConfirmation.subTitle,
      subTitleHtml: attrModalConfirmation.subTitleHtml,
      btnSubmitTitle: attrModalConfirmation.btnSubmitTitle,
      btnBackTitle: attrModalConfirmation.btnBackTitle,
      onHideDialog: hideDialogConfirmation,
      onOnSubmit: returnSnackAct
    }, null, 8, ["show", "imgContent", "title", "subTitle", "subTitleHtml", "btnSubmitTitle", "btnBackTitle"])
  ]))
}
}

})